import styled from 'styled-components';
import { Typography, Checkbox, Box } from '@mui/material';

import { colors } from '../../theme';

interface LabelProps {
    disabled: boolean;
}

interface GlobalCheckboxProps {
    label: string;
    onChange: (name: string, value: string | boolean) => void;
    name: string;
    disabled?: boolean;
    isChecked: boolean;
    useCheckedValue?: boolean;
}

const GlobalCheckbox = (props: GlobalCheckboxProps) => {
    const { label, onChange, name, isChecked, useCheckedValue } = props;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <StyledCheckbox
                {...props}
                color={'primary'}
                size="small"
                value={label}
                checked={isChecked}
                name={name}
                onChange={(e) => {
                    const { target: { name, value, checked }, } = e;
                    if (useCheckedValue)
                        onChange(name, checked);
                    else
                        onChange(name, value);
                }}
            />
            <CheckboxLabel variant="body2" disabled={props.disabled}>
                {label}
            </CheckboxLabel>
        </Box>
    );
};

export default GlobalCheckbox;

const StyledCheckbox = styled(Checkbox)`
    && {
        &.MuiCheckbox-root {
            color: ${colors.blue.main};
        }
        &.Mui-disabled {
            color: ${colors.border};
        }
    }
`;

const CheckboxLabel = styled(Typography) <LabelProps>`
    && {
        text-transform: capitalize;
        line-height: 0;
        font-size: 14px;
        color: ${(props) => props.disabled && colors.border};
    }
`;
